import axios from "axios";

const forgotPassword = ({ email }) => {
    return axios.post(process.env.VUE_APP_FORGOT_PASSWORD, {
        email
    });
};

export default {
    forgotPassword
};
